import { render, staticRenderFns } from "./IntroRequests.vue?vue&type=template&id=6361889e&scoped=true&"
import script from "./IntroRequests.vue?vue&type=script&setup=true&lang=js&"
export * from "./IntroRequests.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361889e",
  null
  
)

export default component.exports